import * as THREE from 'three';
import { getRect, getThreeCamera } from '../../modules/player';
import { getSelectedNodes } from '../../modules/selection';
import { getWorldTransform } from '../../modules/scene';

const axisColors = { x: 0xff0000, y: 0x00ff00, z: 0x0000ff };

const materials = {
  x: new THREE.MeshStandardMaterial({ color: axisColors.x, depthTest: false }),
  y: new THREE.MeshStandardMaterial({ color: axisColors.y, depthTest: false }),
  z: new THREE.MeshStandardMaterial({ color: axisColors.z, depthTest: false }),
};

const lineRadius = 0.02;

function cancelAxis(axis) {
  materials[axis].color = new THREE.Color(axisColors[axis]);
  materials[axis].needsUpdate = true;
}

function resetMaterials() {
  ['x', 'y', 'z'].forEach(cancelAxis);
}

export function getViewScale(store) {
  const viewRect = getRect(store);
  const posObj = new THREE.Vector3().copy(
    (viewRect.height < viewRect.width) ? { x: 0, y: 0.4, z: 0 } : { x: 0.4, y: 0, z: 0 }
  );

  const node = getSelectedNodes(store)[0];
  if (!node) return 0;
  const nodePosition = new THREE.Vector3().setFromMatrixPosition(getWorldTransform(store, node));

  const camera = getThreeCamera(store);
  const cameraPosition = new THREE.Vector3().setFromMatrixPosition(camera.matrix);

  const inverseProjectionMatrix = new THREE.Matrix4().getInverse(camera.projectionMatrix, true);
  const referencePoint = new THREE.Vector3().copy(nodePosition)
    .applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  referencePoint.add(posObj).applyMatrix4(inverseProjectionMatrix).applyMatrix4(camera.matrix);

  const scale = referencePoint.sub(nodePosition).length();
  return scale;
}

export function drawMoveGizmo() {
  resetMaterials();
  const coneRadius = 0.08;
  const cone = new THREE.ConeGeometry(coneRadius, 0.25, 25);
  const yArrow = new THREE.CylinderGeometry(lineRadius, lineRadius, 2, 32);
  const cone2 = cone.clone();
  cone.translate(0, 1, 0);
  cone2.rotateX(Math.PI);
  cone2.translate(0, -1, 0);
  yArrow.merge(cone);
  yArrow.merge(cone2);

  const zArrow = yArrow.clone();
  const xArrow = yArrow.clone();

  const yMesh = new THREE.Mesh(yArrow, materials.y);
  yMesh.axis = 'y';

  zArrow.rotateX(Math.PI / 2);
  const zMesh = new THREE.Mesh(zArrow, materials.z);
  zMesh.axis = 'z';

  xArrow.rotateZ(Math.PI / 2);
  const xMesh = new THREE.Mesh(xArrow, materials.x);
  xMesh.axis = 'x';

  const moveGizmo = new THREE.Object3D();
  moveGizmo.add(xMesh);
  moveGizmo.add(yMesh);
  moveGizmo.add(zMesh);

  return moveGizmo;
};

export function drawRotateGizmo() {
  resetMaterials();
  var xRotation = new THREE.TorusGeometry(1, lineRadius, 16, 100);
  const yRotation = xRotation.clone();
  const zRotation = xRotation.clone();

  xRotation.rotateY(Math.PI / 2);
  yRotation.rotateX(Math.PI / 2);

  const rotateGizmo = new THREE.Object3D();
  const xMesh = new THREE.Mesh(xRotation, materials.x);
  xMesh.axis = 'x';
  const yMesh = new THREE.Mesh(yRotation, materials.y);
  yMesh.axis = 'y';
  const zMesh = new THREE.Mesh(zRotation, materials.z);
  zMesh.axis = 'z';
  rotateGizmo.add(xMesh);
  rotateGizmo.add(yMesh);
  rotateGizmo.add(zMesh);

  return rotateGizmo;
};

export function drawScaleGizmo() {
  resetMaterials();
  const boxWidth = 0.2;
  const box = new THREE.BoxGeometry(boxWidth, boxWidth, boxWidth);
  const yArrow = new THREE.CylinderGeometry(lineRadius, lineRadius, 1, 32);
  yArrow.translate(0, 0.5, 0);
  //const box2 = box.clone();
  box.translate(0, 1, 0);
  //box2.rotateX(Math.PI);
  //box2.translate(0, -1, 0);
  yArrow.merge(box);
  //yArrow.merge(box2);

  const zArrow = yArrow.clone();
  const xArrow = yArrow.clone();

  const yMesh = new THREE.Mesh(yArrow, materials.y);
  yMesh.axis = 'y';

  zArrow.rotateX(Math.PI / 2);
  const zMesh = new THREE.Mesh(zArrow, materials.z);
  zMesh.axis = 'z';

  xArrow.rotateZ(-Math.PI / 2);
  const xMesh = new THREE.Mesh(xArrow, materials.x);
  xMesh.axis = 'x';

  const scaleGizmo = new THREE.Object3D();
  scaleGizmo.add(xMesh);
  scaleGizmo.add(yMesh);
  scaleGizmo.add(zMesh);

  return scaleGizmo;
};

export function highlightAxis(translator, ev, activeAxis) {
  let axis = null;
  const x = ev.clientX / (ev.rect.width / 2) - 1;
  const y = -(ev.clientY / (ev.rect.height / 2) - 1);
  const hits = translator.raycastSelect({ x, y }, 'Widgets');

  if (hits && hits[0] && hits[0].node && hits[0].node.axis) {
    if (activeAxis) cancelAxis(activeAxis);
    axis = hits[0].node.axis;
    materials[axis].color = new THREE.Color(1, 1, 0);
    materials[axis].needsUpdate = true;
    translator.postTranslate('normal', true);
  } else if (activeAxis) {
    cancelAxis(activeAxis);
    translator.postTranslate('normal', true);
  }

  return axis;
};



// WEBPACK FOOTER //
// ./src/translators/tools/gizmos.js